
import VuePdf from 'vue-pdf'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'

import {eventBus} from '../../../eventbus'
export default {
name: 'reportPdf',
components: {VuePdf, Flexbox, FlexboxItem, XButton, Loading},
data () {
return {
$vue: '',
showLoading: false,
loadingText: '加载中',
reportInfo: this.$route.params.data,
caseId: '',
caseType: '',
reportId: '',
reportClass: '',
pdfUrl: '',
canBack: '',
canAdopt: '',
canCopy: '',
method: '',
numPages: '',
pdfSrc: '',
routType: 0,
showRestart: true
}
},
mounted () {
this.pdfSrc = VuePdf.createLoadingTask(this.pdfUrl)
this.pdfSrc.promise.then(VuePdf => {
this.numPages = VuePdf.numPages
console.log('页数' + this.numPages)
})
},
methods: {

async restartDiagnose () {
this.routType = 1

eventBus.$emit('showLoading', true)
let params = new URLSearchParams()
params.append('CASE_ID', this.caseId)
let suc = await this.$http.post(this.$vue.getData('RESTART_DIAGNOSE'), params)
if (suc.data.result === '1') {
let diagnoseType = suc.data.data.diagnoseType

this.$router.push({path: '/diagnosis/' + diagnoseType + '/' + this.caseId, query: {routType: 1}})
}
},
goBack () {
this.$router.go(-1)
},
continueDiag () {











this.$router.push({name: 'HomePage'})
},
adoptReport () {

if (this.caseType === 1) {
this.$router.push({ path: '/celladoptreport/' + this.caseId + '/' + this.reportId })
} else {
this.$router.push({ path: '/tissueadoptreport/' + this.caseId + '/' + this.reportId })
}
},
copyReport () {

if (this.caseType === 1) {

this.$router.push({ path: '/cellreportedit/1/' + this.caseId + '/' + this.reportId })
} else {

this.$router.push({ path: '/tissuereportedit/1/' + this.caseId + '/' + this.reportId })
}
}
},
beforeMount () {
this.routType = 0
this.$vue = this

this.pdfUrl = this.reportInfo.pdfUrl

this.caseId = this.reportInfo.CASE_ID

this.caseType = this.reportInfo.CASE_TYPE

this.reportId = this.reportInfo.REPORT_ID

this.reportClass = this.reportInfo.REPORT_CLASS

this.canBack = this.reportInfo.canBack

this.canAdopt = this.reportInfo.canAdopt

this.canCopy = this.reportInfo.canCopy

this.finishDiagnose = this.$route.params.finishDiagnose

eventBus.$emit('showLoading', false)
if (this.reportInfo.data_result !== '' && this.reportInfo.data_result !== null && this.reportInfo.data_result !== undefined) {
this.showRestart = this.reportInfo.data_result
}
}
}



// WEBPACK FOOTER //
// ./src/components/base/pdf/pdfView.vue